export enum commonFilters {
  GET_FILTERS = "GET_FILTERS",
  GET_FILTERS_SUCCESS = "GET_FILTERS_SUCCESS",
  GET_FILTERS_FAILED = "GET_FILTERS_FAILED",

  ADD_UPDATE_FILTERS = "ADD_UPDATE_FILTERS",
  ADD_UPDATE_FILTERS_SUCCESS = "ADD_UPDATE_FILTERS_SUCCESS",
  ADD_UPDATE_FILTERS_FAILED = "ADD_UPDATE_FILTERS_FAILED",
}
